module.exports = __webpack_public_path__ + "static/media/9.de8df78d.png";